import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AvatarBlockComponent } from './avatar-block.component';
import { AvatarBlockDescriptionDirective, AvatarBlockTitleDirective, AvatarBlockTitleSuffixDirective, UnreadDotDirective } from './avatar-block.directive';
import { MatIconModule } from '@angular/material/icon';
import { AnimatedDirective } from '../directives/animated.directive';
import { MatBadgeModule } from '@angular/material/badge';

const AVATAR_BLOCK_DIRECTIVES = [
    AvatarBlockComponent,
    AvatarBlockTitleDirective,
    AvatarBlockTitleSuffixDirective,
    AvatarBlockDescriptionDirective,
    UnreadDotDirective,
];

@NgModule({
    imports: [
        CommonModule,

        NgOptimizedImage,
        MatIconModule,
        AnimatedDirective,
        MatBadgeModule,
    ],
    declarations: [
        ...AVATAR_BLOCK_DIRECTIVES,
    ],
    exports: [
        ...AVATAR_BLOCK_DIRECTIVES,
    ],
})
export class AvatarBlockModule
{
}
